import { el } from "./dom";
import { createCaseFrame } from "./CaseFrame";

export interface BuiltScreen {
  readonly frame: HTMLElement;
  readonly body: HTMLElement;
}

export function createScreenShell(): BuiltScreen {
  const frame = createCaseFrame();
  const body = el("div", { class: "screen-body" });
  frame.appendChild(body);
  return { frame, body };
}
